export const osnTop107SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M77.56
199L147 39.96V12.24H6.72V47.24H100.8L33.88 199H77.56Z" fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-7-s',
};
